module.exports = __webpack_public_path__ + "static/img/TheresaNewGeneration_Mobile_11.28.dc0fe3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/TheresaNewGeneration_Mobile_11.28.svg
// module id = gG+8
// module chunks = 1